<script>
	import CartProduct from '$lib/components/CartProduct.svelte';
	import { goto, invalidateAll } from '$app/navigation';
	import Loader from '$lib/components/Loader.svelte';
	import check from '$lib/images/check.svg';
	import { page } from '$app/stores';
	import { env as public_env } from '$env/dynamic/public';
	import { clickOutside } from '$lib/utils/click_outside.js';
	import { variables } from '$lib/variables';
	import { lang } from '$lib/translations/category/index.js';
	import { onMount } from 'svelte';
	import PopularMes from '$lib/components/PopularMes.svelte';
	import FilterBlock from '$lib/components/FilterBlock.svelte';
	export let data;
	let sortOpen = false;
	
	let colorOpen = false;
	let typeOpen = false;
	let BrandOpen = false;
	let CategoryOpen = false;
	let product__category__slug = $page.params.category;
	let product__brand__slug = $page.url.searchParams.get('product__brand__slug') || '';
	let load = false;
	let ordering = $page.url.searchParams.get('ordering') || 'popular';
	let color__id = $page.url.searchParams.get('color__id') || '';
	let type__id = $page.url.searchParams.get('type__id') || '';
	async function OnGetNewPage() {
		load = true;
		let url = data.products.next;

		url = `${url}`;
		const res = await fetch(url);

		let results = await res.json();

		data.products.results.products = [
			...data.products.results.products,
			...results.results.products
		];
		data.products.next = results.next;
		load = false;
	}
	function OnGetFt(params) {
		load = true;
		let url = `${variables.basePathApi}/api/v1/products-atributes/${params}`;

		fetch(url)
			.then((res) => res.json())
			.then((results) => {
				data.products = {
					count: 1,
					next: null,
					previous: null,
					results: {
						products: [],
						brands: data.products.results.brands,
						categories: data.products.results.categories,
						colors: data.products.results.colors
					}
				};

				setTimeout(() => {
					console.log('results.count',results.count);
					
					data.products.count = results.count;
					data.products.next = results.next;
					data.products.previous = results.previous;
					data.products.results.products = results.results.products;
					load = false;
				}, 1000);
			})
			.catch((error) => console.error(error));
	}

	async function onGetFilters() {
		load = true;

		let params =
			`?product__category__slug=${$page.params.category}&page=1&page_size=50&product__brand__slug=${product__brand__slug}` +
			`&color__id=${colors__id}&ordering=${ordering}&sizes__id=${sizes__id}&product__brand__id=${brands__id}`;
		OnGetFt(params);
		// goto(params);fg
		// // location.href = params
		// // load = false;
		// invalidateAll()
	}
	async function OnFilterBrand(slug) {
		BrandOpen = false;
		product__brand__slug = slug;
		await onGetFilters();
	}

	async function OnFilterSort(sort) {
		sortOpen = false;
		ordering = sort;
		await onGetFilters();
	}
	const OnFilterSend = async () => {
		await onGetFilters();
	};
	async function ResetFilter() {
		load = true;
		setTimeout(() => {
			product__brand__slug = '';
			ordering = 'popular';
			color__id = '';

			location.href = `/${$page.params.category}`;
			load = false;
		}, 500);
	}
	$: innerWidth = 0;
	let observ = false;
	let path_file = variables.basePathApi;
	onMount(() => {
		const observerFilter = document.getElementById('observer-filter');
		const navApp = document.querySelector('.nav-app');
		const observerFilterProducts = document.querySelector('.observer-filter-products');
		let lastScrollTop = 0; // Переменная для хранения последней позиции скролла
	});
	let sizes__id = '';
	let colors__id = '';
	let brands__id = '';
	let colors = data.products.results.colors;
	let sizes = data.products.results.sizes;
	let brands = data.products.results.brands;
	$: if ($page.params.category) {
		UpdateSlug();
	}
	const UpdateSlug = () => {
		colors = $page.data.products.results.colors;
		sizes = $page.data.products.results.sizes;
		brands = $page.data.products.results.brands;
	};
</script>

<svelte:window bind:innerWidth />

<svelte:head>
	<title>Iloveitalianbags - {$page.data.category?.name} {lang[$page.data.host]['izitaly']}.</title>
	<meta
		name="description"
		content="{$page.data.category?.name}  {lang[$page.data.host][
			'izitaly'
		]}. Только оригинальная продукция. Быстрая доставка"
	/>
	<meta
		data-n-head="ssr"
		data-hid="og:description"
		property="og:description"
		content="{$page.data.category?.name}  {lang[$page.data.host][
			'izitaly'
		]}. Только оригинальная продукция. Быстрая доставка"
	/>
	<meta
		data-n-head="ssr"
		data-hid="og:description"
		name="og:description"
		content="{$page.data.category?.name}  {lang[$page.data.host][
			'izitaly'
		]}. Только оригинальная продукция. Быстрая доставка"
	/>
	<meta
		data-n-head="ssr"
		data-hid="og:title"
		property="og:title"
		content="Iloveitalianbags - {$page.data.category?.name}  {lang[$page.data.host]['izitaly']}."
	/>
	<meta
		data-n-head="ssr"
		data-hid="og:title"
		name="og:title"
		content="Iloveitalianbags - {$page.data.category?.name}  {lang[$page.data.host]['izitaly']}."
	/>
	<meta
		name="og:description"
		content="{$page.data.category?.name}  {lang[$page.data.host][
			'izitaly'
		]}. Только оригинальная продукция. Быстрая доставка"
	/>
	<meta
		data-n-head="ssr"
		data-hid="og:url"
		name="og:url"
		content={`/${$page.data.category?.slug}`}
	/>
	<meta
		property="og:image"
		content="https://iloveitalianbags.ru//media/category_logos/compp_GXZPsVG.webp"
	/>
	<meta property="og:image:width" content="1200" />
	<meta property="og:image:height" content="630" />

	<link rel="canonical" href={`https://iloveitalianbags.ru/${$page.data.category?.slug}`} />
</svelte:head>
{#if $page.data.category}
	{#if load}
		<Loader />
	{/if}
	<div
		class="bg-cover md:h-[100vh] h-[90vh] bg-center md:mt-0 mt-14 bg-no-repeat flex justify-center items-center"
		style="background-image: url({innerWidth > 768
			? $page.data.category.logo
				? `${path_file}${$page.data.category.logo}`
				: `${path_file}/media/category_logos/compp_GXZPsVG.webp`
			: $page.data.category.logomob
			? `${path_file}${$page.data.category.logomob}`
			: `${path_file}/media/category_logos/mobs_1jJuAo3.webp`});"
	>
		<div class="flex flex-col justify-center items-center">
			<h1 class="text-[24px] md:text-[48px] text-custom-white-bg text-center">
				{$page.data.category[`name${$page.data.host}`]}
				{lang[$page.data.host]['izitaly']}
			</h1>
			<p class="md:text-xl text-[16px] px-[2em] md:px-1 mt-[7px] text-custom-white-bg text-center">
				Made in Italy 100%
			</p>
		</div>
	</div>
	<!--!!!  Start observer filter block -->

	<div id="observer-filter2" class="z-20" class:shadow-md={observ}>
		{#if $page.data.products.results.categories.length > 1}
			<!-- Active filters -->
			<div class="bg-gray-100 px-[16px] md:px-[23px] py-[23px] md:py-[40px]">
				<div class="flex flex-col m-auto p-auto">
					<div class="flex overflow-x-scroll pb-2 hide-scroll-bar">
						{#each $page.data.products.results.categories as item, ind}
							<div class="mt-2 ml-4">
								<!-- svelte-ignore a11y-click-events-have-key-events -->
								<!-- svelte-ignore a11y-no-static-element-interactions -->
								<div
									on:click={() => {
										load = true;
										setTimeout(() => {
											load = false;
										}, 1000);
									}}
									class="-m-1 flex flex-wrap items-center"
								>
									{#if $page.data.category?.name != item.name}
										<a
											data-sveltekit-noscroll
											href="/{item.slug}"
											class="bg-gray-200 min-w-max text-gray-800 rounded-md px-3 py-2 text-sm font-medium"
											aria-current="page">{item[`name${$page.data.host}`]}</a
										>
									{/if}
								</div>
							</div>
						{/each}
					</div>
				</div>
			</div>
		{/if}
	</div>

	<section class="block md:hidden mt-3">
		{#if BrandOpen}
			<ul
				class="w-full mt-1 max-h-60 overflow-auto rounded-md bg-white text-base mb-4 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
				tabindex="-1"
				role="listbox"
				aria-labelledby="listbox-label"
				aria-activedescendant="listbox-option-3"
			>
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
				<li
					on:click={() => {
						ResetFilter();
					}}
					style="border-bottom: 0.5px solid #D9D9D9;"
					class="text-gray-900 text-center flex justify-center items-center h-[30px] relative cursor-pointer select-none py-2 pl-3 pr-9"
					id="listbox-option-0"
				>
					<span class="font-normal text-base text-custom-gray block truncate">Все</span>
				</li>
				{#each data.products.results.brands as item, ind}
					<!-- svelte-ignore a11y-click-events-have-key-events -->
					<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
					<li
						on:click={() => {
							OnFilterBrand(item.slug);
						}}
						style="border-bottom: 0.5px solid #D9D9D9;"
						class="text-gray-900 text-center flex justify-center items-center h-[30px] relative cursor-pointer select-none py-2 pl-3 pr-9"
						id="listbox-option-0"
					>
						<span class="font-normal text-base text-custom-gray block truncate">{item.name}</span>
					</li>
				{/each}
			</ul>
		{/if}
		{#if sortOpen}
			<ul
				class="w-full mt-1 max-h-60 overflow-auto rounded-md bg-white text-base mb-4 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
				tabindex="-1"
				role="listbox"
				aria-labelledby="listbox-label"
				aria-activedescendant="listbox-option-3"
			>
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
				<li
					on:click={() => {
						OnFilterSort('popular');
					}}
					style="border-bottom: 0.5px solid #D9D9D9;"
					class="text-gray-900 text-center flex justify-center items-center h-[30px] relative cursor-pointer select-none py-2 pl-3 pr-9"
					id="listbox-option-0"
				>
					<span class="font-normal text-base text-custom-gray block truncate"
						>{lang[$page.data.host]['popular']}</span
					>
				</li>

				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
				<li
					on:click={() => {
						OnFilterSort('-id');
					}}
					style="border-bottom: 0.5px solid #D9D9D9;"
					class="text-gray-900 text-center h-[30px] flex justify-center items-center relative cursor-pointer select-none py-2 pl-3 pr-9"
					id="listbox-option-0"
				>
					<span class="font-normal text-base text-custom-gray block truncate"
						>{lang[$page.data.host]['news']}</span
					>
				</li>
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
				<li
					on:click={() => {
						OnFilterSort('-price');
					}}
					style="border-bottom: 0.5px solid #D9D9D9;"
					class="text-gray-900 text-center h-[30px] flex justify-center items-center relative cursor-pointer select-none py-2 pl-3 pr-9"
					id="listbox-option-0"
				>
					<span class="font-normal text-base text-custom-gray block truncate"
						>{lang[$page.data.host]['pricefrom']}</span
					>
				</li>
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
				<li
					on:click={() => {
						OnFilterSort('price');
					}}
					style="border-bottom: 0.5px solid #D9D9D9;"
					class="text-gray-900 text-center h-[30px] flex justify-center items-center relative cursor-pointer select-none py-2 pl-3 pr-9"
					id="listbox-option-0"
				>
					<span class="font-normal text-base text-custom-gray block truncate"
						>{lang[$page.data.host]['ppriceto']}</span
					>
				</li>
			</ul>
		{/if}
	</section>

	<FilterBlock
		{colors}
		{sizes}
		{brands}
		bind:colors__id
		bind:sizes__id
		bind:load
		bind:count={data.products.count}
		bind:brands__id
		{OnFilterSort}
		{OnFilterSend}
	/>

	<!-- PRODUCTS -->
	{#if $page.data.products}
		{#if data.products.results.products.length > 0}
			<div
				class="grid observer-filter-products mt-[2px] min-h-screen grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[2px]"
			>
				{#each data.products.results.products as item, ind (item.id)}
					{#if ind == 6 && data.category.pages_photos.length > 0}
						<div
							class="col-span-2 h-[400px] md:h-full md:col-span-2
		bg-cover
		bg-no-repeat"
							style="background-image: url({data.category.pages_photos[0].logo});"
						/>
					{/if}

					{#if ind == 10 && data.category.pages_photos.length > 1}
						<div
							class="col-span-2 h-[400px] md:h-full md:col-span-2
	bg-cover
	bg-no-repeat"
							style="background-image: url({data.category.pages_photos[1].logo});"
						/>
					{/if}
					<CartProduct {item} {ind} />
				{/each}
			</div>
		{:else}
			<h2 class="w-full text-center text-custom-gray text-2xl">
				{#if !load}
					Ничего не найдено
				{/if}
			</h2>
		{/if}

		<div class="h-[20vh] pb-10 pt-10 flex justify-center">
			{#if data.products.next}
				<button
					style="border: 2px solid #000000;"
					class="text-base text-custom-black h-max w-max py-[20px] md:py-[14px] md:px-[32px] px-[20px] flex justify-center items-center"
					on:click={() => {
						OnGetNewPage();
					}}
				>
					{lang[$page.data.host]['seeAll']}
				</button>
			{/if}
		</div>
	{/if}
{/if}
<PopularMes />

<style>
	.hide-scroll-bar {
		-ms-overflow-style: none;
		scrollbar-width: none;
	}
	.hide-scroll-bar::-webkit-scrollbar {
		display: none;
	}
</style>
